import { KYMW9011Component } from './kymw9011.component';

/**
 * パスワード再設定画面の値を管理するクラス
 *
 * @export KYMW9011Model
 * @class KYMW9011Model
 */
export class KYMW9011Model {
  kYMW9011Component: KYMW9011Component;
  // 認証コード
  public confirmCode: string = '';
  // 新しいパスワード
  public newPassword: string = '';
  // 新しいパスワード（確認）
  public newPasswordCheck: string = '';
}
